import React from 'react';
import './home.css';
import RodapeMrv from '../../assets/img/rodape.svg';
import RodapeMobileMrv from '../../assets/img/rodapeMobile.svg';
import AuthService from '../../lib/api/auth/authService';
import { LoadingIndicator } from '@company-mrv/mrv-design-system/components';
import CadastroParametros from './cadastroParametros/cadastroParametros';
import ConsultaLogs from './consultaLogs/consultaLogs';
import { PermissoesUsuario } from '../../lib/share/utils/constantes';
import { SessionStorageUtils } from '../../lib/share/utils/sessionStorageUtils';

interface ParametroModel 
{
    nome: string;
    valor: string;
    componente: JSX.Element;
}

class Home extends React.Component<{}, { autorizado?: boolean }> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    componentDidMount() 
    {
        AuthService.autorizar()
        .then((res) => {
            globalThis.sessionStorage.setItem("permissoes", JSON.stringify(res.data));
            this.setState({ autorizado: true });
        })
        .catch(() => {this.setState({ autorizado: false })});     
    }

    verificarPermissoes(permissao: any) {
        const permissoesAtuais = SessionStorageUtils.getItemsFromSessionStorage("permissoes");
        
        if (permissoesAtuais === null) return false;
        
        const permissaoUpper = permissao.toUpperCase();
        const permissoesUpper = permissoesAtuais.map((p: string) => p.toUpperCase());
        
        return permissoesUpper.includes(permissaoUpper);
    }

    render()
    {
        return (
            <div className="container-home">
                <main className="conteudo-principal">
                    {
                        this.state.autorizado &&
                        (
                                <section className={`card-grupo ${this.verificarPermissoes(PermissoesUsuario.VisualizarLogs) ? '' : 'centralizado'}`}>
                                    <CadastroParametros />
                                    {
                                        this.verificarPermissoes(PermissoesUsuario.VisualizarLogs) && 
                                        <ConsultaLogs />
                                    }
                                </section>
                        )
                    }
                    {
                        this.state.autorizado === false &&
                        (
                            <section className="card-principal">
                                <h1 className="titulo">O usuário não possui acesso a esta aplicação.</h1>
                            </section>
                        )
                    }
                    {
                        this.state.autorizado === undefined &&
                        (
                            <LoadingIndicator css={undefined} />
                        )
                    }
                </main>
                <img className="rodape" src={RodapeMrv} alt="Rodapé da página com alguns prédios em um fundo verde" />
                <img className="rodape-mobile" src={RodapeMobileMrv} alt="Rodapé da página com alguns prédios em um fundo verde" />
            </div>
        );
    }
}

export default Home